import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  rozetka:
    'https://rozetka.com.ua/ua/chesterfield_4823003205694/p49667814/?utm_source=PMUsmsChePrif',
  cigPoshta:
    'https://cig-poshta.in.ua/chesterfield-blue/?utm_source=CDAsmsChePrif'
};

const HomeScreen = ({ backgroundImage }) => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3(
            'images/sms-che-prif/bg.png'
          )})`
        }}
      >
        <p className={styles.title}>Chesterfield Blue</p>
        <img
          src={getImageFromS3('images/sms-che-prif/price-label.png')}
          alt="price-label"
          className={styles.priceLabel}
        />
        <img
          src={getImageFromS3('images/sms-che-prif/characteristics.png')}
          alt="characteristics"
          className={styles.characteristics}
        />
        <p className={styles.disclaimer}>
          *Зазначено задекларовану максимальну роздрібну ціну з урахуванням
          акцизного податку на роздрібний продаж тютюнових виробів станом на
          травень 2025 року
        </p>
        <img
          src={getImageFromS3('images/sms-che-prif/qr-pack.png')}
          alt="qr-pack"
          className={styles.qrPack}
        />
        <div className={styles.filterTobaccoContainer}>
          <div className={styles.filterContainer}>
            <img
              src={getImageFromS3('images/sms-che-prif/filter.png')}
              alt="filter"
              className={styles.qrPack}
            />
            <p>
              <b>Ацетатний</b>
              <br></br> фільтр
            </p>
          </div>
          <div className={styles.tobaccoContainer}>
            <img
              src={getImageFromS3('images/sms-che-prif/tobacco.png')}
              alt="filter"
              className={styles.qrPack}
            />
            <p>
              Бленд з{' '}
              <b>
                трьох<br></br> сортів
              </b>{' '}
              тютюну
            </p>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            <b>Сhesterfield Blue*</b> можна знайти у роздрібних точках продажу в
            твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <button
              onClick={() => {
                sendEvent('rozetka');
                window.open(shopLink.rozetka, '_blank');
              }}
            >
              <img
                src={getImageFromS3('images/sms-che-prif/glass.png')}
                alt="button-bg"
              />
              <p>Rozetka</p>
            </button>
            <button
              onClick={() => {
                sendEvent('cig-poshta');
                window.open(shopLink.cigPoshta, '_blank');
              }}
            >
              <img
                src={getImageFromS3('images/sms-che-prif/glass.png')}
                alt="button-bg"
              />
              <p>Cig-poshta</p>
            </button>
          </div>
          <p className={styles.buyDisclaimer}>
            *Регулярний продукт (без відривної частини) також доступний у точках
            продажу. Продукт має відмінний дизайн внутрішньої рамки, але
            незмінні продуктові характеристики.
          </p>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-che-prif">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
